export const CONFIG = {
  APP_CONFIGS: "application/get?languageId=13",
  LANGUAGES: "application/app_languages",
  LAUNCHER_REGISTER: "launcher/register",
  GET_LAUNCHER_USER: "launcher/get_user",
  LOGIN_USER: "launcher/login_app",
  LOGIN_USER_CREDENTIALS: "user/login",
  GET_CHANNELS: "v2/api/channels",
  CHANNEL_INFO: "v2/api/channels/info",
  GET_ARCHIVE_URL: "v2/api/channels/archived_url",
  CATEGORIES_CHANNEL: "v2/api/category",
  EPG_LIST: "user/epg/getByDate",
  GET_PROFILE: "user/subUser/getByRootUserId",
  GET_MOVIES: "v2/api/movies",
  TRANSLATIONS: "application/app_languages",
  APP_TRANSLATIONS: "application/translations",
  CHANGE_LANG: "user/language",
};
